import store from '~/store'

export default async (to, from, next) => {
    if (!store.getters['auth/check'] && store.getters['auth/token']) {
        try {
            await store.dispatch('auth/fetchUser')
        } catch (e) {
        }
    }

    next()
}



// WEBPACK FOOTER //
// ./resources/assets/js/middleware/check-auth.js